import React from 'react';
import { NotificationsWrapper, HeaderAlt, TitleWrapper, Title } from './PrivacySettings.styles';
import Button from '../FinancingTerms/shared/Button';

type OwnProps = {
  onRetry: () => void;
};

const ConsentError = ({ onRetry }: OwnProps) => {
  const handleRetry = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onRetry();
  };
  return (
    <NotificationsWrapper>
      <HeaderAlt>
        <TitleWrapper>
          <Title>Privacy Settings Unavailable</Title>
        </TitleWrapper>
      </HeaderAlt>

      <div style={{ padding: '20px 0' }}>
        <div>
          <h4>Unable to load Privacy Settings</h4>
          <p>
            We're unable to load your privacy settings at this time. This may be due to a temporary
            connection issue or server maintenance.
          </p>

          <div style={{ margin: '20px 0' }}>
            <Button href="#" type="button" data-qa="retry-consent-button" onClick={handleRetry}>
              Try Again
            </Button>
          </div>
        </div>
      </div>

      <p>
        For more information about our privacy practices, please review{' '}
        <a href="/privacy-policy">Carvana's Consumer Privacy Notice</a>.
      </p>
    </NotificationsWrapper>
  );
};

export default ConsentError;
